import store from "../store";
import { i18n } from "@/locales/index.js";
import guid from "./middleware/guid";

const load = component => {
  return () =>
    import(`@/views/${component}.vue`);
}

const isCompleted = route => {
  return store.getters["common/isCompleted"](route);
};

export default [
  {
    path: "/",
    redirect: { name: 'PersonalDetails' }
  },
  {
    name: "Agent",
    path: "agent",
    component: load("Agent"),
    progressionBar: false
  },
  {
    name: "Situation",
    path: "situation",
    component: load("Situation"),
    progressionBar: true,
    children: [
      {
        name: "PersonalDetails",
        path: "personal-details",
        component: load("Situation/PersonalDetails")
      },
      {
        name: "SituationContext",
        path: "context",
        component: load("Situation/SituationContext"),
        beforeEnter(to, from, next) {
          let previousRoute = "PersonalDetails";
          if (isCompleted(previousRoute)) next();
          else next({ name: previousRoute, params: {locale: i18n.locale} });
        }
      },
      // {
      //   name: "Consumption",
      //   path: "consumption",
      //   component: load("Situation/Consumption"),
      //   beforeEnter(to, from, next) {
      //     let previousRoute = "SituationContext";
      //     if (isCompleted(previousRoute)) next();
      //     else next({ name: previousRoute, params: {locale: i18n.locale} });
      //   }
      // }
    ]
  },
  {
    name: "Offer",
    path: "offer",
    component: load("Offer"),
    beforeEnter(to, from, next) {
      let previousRoute = "SituationContext";
      if (isCompleted(previousRoute)) next();
      else next({ name: previousRoute, params: {locale: i18n.locale} });
    },
    progressionBar: true
  },
  {
    name: "Contract",
    path: "contract",
    component: load("Contract"),
    beforeEnter(to, from, next) {
      let previousRoute = "Offer";
      if (isCompleted(previousRoute)) next();
      else next({ name: previousRoute, params: {locale: i18n.locale} });
    },
    progressionBar: true
  },
  {
    name: "PriceIncrease",
    path: "price-increase",
    component: load("PriceIncrease"),
    progressionBar: false
  },
  {
    name: "Payment",
    path: "payment",
    component: load("Payment"),
    beforeEnter(to, from, next) {
      let previousRoute = "Contract";
      if (isCompleted(previousRoute)) {
        next();
      } else {
        next({ name: previousRoute, params: {locale: i18n.locale} });
      }
    },
    progressionBar: true
  },
  {
    name: "Confirmation",
    path: "confirmation",
    component: load("Confirmation"),
    beforeEnter(to, from, next) {
      let previousRoute = "Payment";
      if (isCompleted(previousRoute)) next();
      else next({ name: previousRoute, params: {locale: i18n.locale} });
    },
    progressionBar: false
  },
  {
    name: "Proposal",
    path: "proposal",
    component: load("Proposal"),
    beforeEnter(to, from, next) {
      let previousRoute = "Payment";
      if (isCompleted(previousRoute)) next();
      else next({ name: previousRoute, params: {locale: i18n.locale} });
    },
    progressionBar: false
  },
  {
    name: "Consent",
    path: "consent",
    component: load("Consent"),
    beforeEnter(to, from, next) {
      let previousRoute = "Payment";
      if (isCompleted(previousRoute)) next();
      else next({ name: 'PersonalDetails', params: {locale: i18n.locale} });
    },
    progressionBar: false
  },
  {
    name: "Cancel",
    path: "/cancel/:id(\\d+)/:guid",
    component: load("Cancel"),
    progressionBar: false
  },
  {
    path: "comeback",
    name: "Comeback",
    component: load("Comeback"),
    beforeEnter: (to, from, next) => {
      if (to.query.client && to.query.g1 && to.query.g2) {
        store.commit("comeback/setCustomerId", to.query.client);
        store.commit("comeback/setUuid1", to.query.g1);
        store.commit("comeback/setUuid2", to.query.g2);
        next();
      } else {
        next("/");
      }
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js